import request from '@/utils/request'
/**
 * 添加自定义3D建筑
 * @param {Object} config 设置
 */
function addLayer(config) {
  let mapbox = this.mapbox
  for (let file in config) {
    const cfg = config[file]
    const url = config.url || './map/json/build/' + file + '.json'
    const color = cfg.color
    //获取光流数据
    request.get(url).then(res => {
      let data = []
      // 加工数据
      for (let d of res.features) {
        let points = {
          type: 'Feature',
          properties: d.attributes,
          geometry: {
            type: 'Polygon',
            coordinates: d.geometry.rings
          }
        }
        data.push(points)
      }
      // 添加图层
      mapbox.addLayer(
        {
          id: '3d-buildings-' + file,
          source: {
            type: 'geojson',
            data: { type: 'FeatureCollection', features: data }
          },
          type: 'fill-extrusion',
          minzoom: 12,
          paint: {
            'fill-extrusion-color': color,
            'fill-extrusion-height': [
              'interpolate',
              ['linear'],
              ['zoom'],
              14,
              0,
              15.05,
              ['*', 5, ['get', 'Floor']]
            ],
            'fill-extrusion-base': 0,
            'fill-extrusion-opacity': 0.8
          }
        },
        '3d-buildings'
      )
      mapbox.addLayer(
        {
          id: 'building-' + file,
          type: 'fill',
          source: {
            type: 'geojson',
            data: { type: 'FeatureCollection', features: data }
          },
          paint: {
            'fill-color': color,
            'fill-outline-color': {
              stops: [
                [15, 'rgba(212, 177, 146, 0)'],
                [16, 'rgba(212, 177, 146, 0.5)']
              ]
            },
            'fill-opacity': {
              base: 1,
              stops: [[13, 0], [15, 1]]
            },
            'fill-antialias': true
          }
        },
        'building'
      )
    })
  }
}
export default addLayer



// WEBPACK FOOTER //
// ./src/framework/map/layer/Building-3D.js